import { AutoLogout } from "@/setup/auto-logout";
import {
	logbookRoutesMESF,
	TimeService,
	useHasPermission,
} from "@dexteel/mesf-core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useAssetId } from "./hooks/useAssetId";
import {
	getEquivalentRoute,
	getHomePathByAssetId,
	isRouteAllowedForMill1,
	MILL_1_CONFIG,
	MILL_2_CONFIG,
} from "./mill-config/mill-extended-config";
import { adjustmentRoutes } from "./routes/adjustment.routes";
import { calendarRoute } from "./routes/calendar.routes";
import { calendarYearRoute } from "./routes/calendar-year.routes";
import { catalogRoutes } from "./routes/catalog.routes";
import { delayRoutes } from "./routes/delay.routes";
import { formRoutes } from "./routes/forms.routes";
import { millRoutes } from "./routes/mill.routes";
import { reportRoutes } from "./routes/report.routes";
import { rollshopRoutes } from "./routes/rollshop.routes";
import { routeSales, salesRoutes } from "./routes/sales.routes";
import { shiftReportRoutes } from "./routes/shift_report.routes";
import { incentiveRoutes } from "./routes/incentive.routes";
import { stackerPulpitRoutes } from "./routes/stacker-pulpit.routes";
import { m1Routes } from "./routes/m1.routes";

const timezone = TimeService.getInstance().getServerTimeZone();
moment.tz.setDefault(timezone);

const routeSections = [
	{ routes: delayRoutes },
	{ routes: formRoutes },
	{ routes: reportRoutes },
	{ routes: millRoutes },
	{ routes: calendarRoute },
	{ routes: calendarYearRoute },
	{ routes: catalogRoutes },
	{ routes: logbookRoutesMESF },
	{ routes: rollshopRoutes },
	{ routes: adjustmentRoutes },
	{ routes: shiftReportRoutes },
	{ routes: incentiveRoutes },
	{ routes: stackerPulpitRoutes },
	{ routes: m1Routes },
	{ routes: salesRoutes },
];

const CustomRoutes = () => {
	const navigate = useNavigate();
	const hasPermissionTo = useHasPermission();

	const assetId = useAssetId();
	const home =
		hasPermissionTo("ui.navbar.sales") &&
		// Sales Profile uses the sales-specific calendar permission since
		// "ui.navbar.calendar" was removed from it (commit 9f085e460).
		hasPermissionTo("ui.navbar.calendar.sales") &&
		!hasPermissionTo("ui.navbar.mill")
			? routeSales
			: getHomePathByAssetId(assetId);

	useEffect(() => {
		const isMill1Route = isRouteAllowedForMill1(location.pathname);
		const isExclusiveM1Route = location.pathname.startsWith("/m1/");

		if (!isMill1Route && assetId === MILL_1_CONFIG.id) {
			navigate(getEquivalentRoute(location.pathname, assetId));
		} else if (isExclusiveM1Route && assetId === MILL_2_CONFIG.id) {
			navigate(getEquivalentRoute(location.pathname, assetId));
		}
	}, [assetId]);

	return (
		<AutoLogout>
			<LocalizationProvider
				dateAdapter={AdapterMoment}
				dateLibInstance={moment}
			>
				<Routes>
					<Route path={"/"} element={<Navigate to={home} replace />} />
					<Route path={"/home"} element={<Navigate to={home} replace />} />

					{routeSections.map((section, index) => {
						return section.routes.map((route) => {
							return (
								<Route
									key={`route-${route.path}`}
									path={route.path}
									element={route.element}
								/>
							);
						});
					})}
				</Routes>
			</LocalizationProvider>
		</AutoLogout>
	);
};

export { CustomRoutes };
